
// TODO: deprecated, legacy theme configs - need delete after remove all styles from project

export const DEFAULT_THEME = 'dokka';

export const themeLoaders = {
  bdo: () => import('styles/bdoTheme'),
  dokka: () => import('styles/dokkaTheme'),
  profitian: () => import('styles/profitianTheme'),
  autodok: () => import('styles/autodokTheme'),
  made: () => import('styles/madeTheme'),
  nextAge: () => import('styles/nextAgeTheme'),
};

export const getThemeLoader = (theme) => themeLoaders[theme] || themeLoaders[DEFAULT_THEME];
